import { NavLink } from "react-router-dom";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Divider,
  useTheme,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PublicIcon from "@mui/icons-material/Public";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CampaignIcon from "@mui/icons-material/Campaign";
import MailIcon from "@mui/icons-material/Mail";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PeopleIcon from "@mui/icons-material/People";

const AdminSidebar = ({
  anchor = "left",
  open = true,
  onToggle,
  drawerWidth = 220,
  collapsedWidth = 64,
}) => {
  const theme = useTheme();

  const width = open ? drawerWidth : collapsedWidth;
  const transition = theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  });

  
  return (
    <Drawer
      variant="permanent"
      anchor={anchor}
      sx={{
        width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width,
          overflowX: "hidden",
          whiteSpace: "nowrap",
          transition,
          boxSizing: "border-box",
          bgcolor: "primary.main",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.appBar - 1,
          borderRight:
            anchor === "left" ? "1px solid rgba(255,255,255,0.15)" : "none",
          borderLeft:
            anchor === "right" ? "1px solid rgba(255,255,255,0.15)" : "none",
        },
      }}
    >
      {/* Header area داخل الـ sidebar */}
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: anchor === "left" ? "flex-end" : "flex-start",
          px: 1,
          py: 0.5,
          minHeight: 48,
        }}
      >
        <IconButton
          onClick={onToggle}
          size="small"
          aria-label={open ? "Collapse sidebar" : "Expand sidebar"}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />

      <List sx={{ pt: 1 }}>
        <ListItemButton
          component={NavLink}
          to="/admin/dashboard"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <DashboardIcon />
          </ListItemIcon>
          {open && <ListItemText primary="لوحة التحكم " />}
        </ListItemButton>

        <ListItemButton
          component={NavLink}
          to="/admin/products"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <InventoryIcon />
          </ListItemIcon>
          {open && <ListItemText primary="المنتجات" />}
        </ListItemButton>
        
        <ListItemButton
          component={NavLink}
          to="/admin/orders"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <ShoppingCartIcon />
          </ListItemIcon>
          {open && <ListItemText primary="الطلبات" />}
        </ListItemButton> 
        <ListItemButton
          component={NavLink}
          to="/admin/countries"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <PublicIcon />
          </ListItemIcon>
          {open && <ListItemText primary="الدول والعملات" />}
        </ListItemButton>

        <ListItemButton
          component={NavLink}
          to="/admin/shipping-companies"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <LocalShippingIcon />
          </ListItemIcon>
          {open && <ListItemText primary="الشحن" />}
        </ListItemButton>

        
        <ListItemButton
          component={NavLink}
          to="/admin/advertising-banners"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <CampaignIcon />
          </ListItemIcon>
          {open && <ListItemText primary="الإعلانات والعروض" />}
        </ListItemButton>

        <ListItemButton
          component={NavLink}
          to="/admin/contact-messages"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <MailIcon />
          </ListItemIcon>
          {open && <ListItemText primary="رسائل التواصل" />}
        </ListItemButton>
        
        <ListItemButton
          component={NavLink}
          to="/admin/admin-accounts"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <AdminPanelSettingsIcon />
          </ListItemIcon>
          {open && <ListItemText primary="حسابات الأدمن" />}
        </ListItemButton>
        <ListItemButton
          component={NavLink}
          to="/admin/clients-accounts"
          sx={{
            color: "#fff",
            "&.active": { bgcolor: "primary.dark" },
            justifyContent: open ? "initial" : "center",
            px: open ? 2 : 1,
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0 }}>
            <PeopleIcon />
          </ListItemIcon>
          {open && <ListItemText primary="حسابات العملاء" />}
        </ListItemButton>
        
      </List>

      {/* fill remaining space to keep drawer full height */}
      <Box sx={{ flexGrow: 1 }} />
    </Drawer>
  );
};

export default AdminSidebar;